import { render, staticRenderFns } from "./relacionarOficios.view.vue?vue&type=template&id=04594c6d"
import script from "./relacionarOficios.view.vue?vue&type=script&lang=js"
export * from "./relacionarOficios.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports